import { SET_NPS_OPEN, SET_NPS_PROCESS_TYPE } from '../actionTypes';

const initialState = {
  isNPSOpen: false,
  npsProcessType: '',
};

const npsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NPS_OPEN:
      return {
        ...state,
        isNPSOpen: action.payload,
      };
    case SET_NPS_PROCESS_TYPE:
      return {
        ...state,
        npsProcessType: action.payload,
      };
    default:
      return state;
  }
};

export default npsReducer;